import React from "react";
// React Router
import { Route, Redirect } from "react-router-dom";

const GuardedRoute = ({ component: Component, condition, redirect, ...rest }) => (
  <Route {...rest} render={({ match, ...props }) => (condition ? <Component {...rest} {...props} {...match} /> : <Redirect to={redirect} />)} />
);

export default GuardedRoute;
